var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetTypeCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.395 21.7178C37.395 12.785 30.1538 5.54373 21.2209 5.54373C12.2888 5.54373 5.04688 12.785 5.04688 21.7178C5.04688 27.6733 9.87485 32.5005 15.8296 32.5005H26.6123C32.5677 32.5005 37.395 27.6733 37.395 21.7178Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8665 13.0239H15.6641V15.4287H18.0688V13.0239H16.8665ZM26.7392 15.4287V13.0239H24.3344V15.4287H26.7392Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2195 19.3098V22.0054C21.2196 22.3594 21.1499 22.7099 21.0145 23.0369C20.8791 23.3639 20.6806 23.6611 20.4304 23.9113C20.1801 24.1618 19.8829 24.3605 19.5557 24.496C19.2286 24.6316 18.878 24.7013 18.5239 24.7012C17.0351 24.7012 15.8281 23.4942 15.8281 22.0054",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2188 19.3098V22.0054C21.2188 22.3594 21.2886 22.7099 21.4241 23.0369C21.5596 23.364 21.7582 23.6611 22.0086 23.9113C22.2588 24.1618 22.5559 24.3604 22.8829 24.4959C23.2099 24.6315 23.5604 24.7012 23.9144 24.7012C25.4038 24.7012 26.6101 23.4942 26.6101 22.0054",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 19.3096H22.5629",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73917 19.022H1",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4345 19.022H34.6953",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73917 24.4141H1",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4345 24.4141H34.6953",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39062 14.0713V1.49964C8.97939 1.4998 11.4628 2.52808 13.2935 4.35837L15.1419 6.21391",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0922 14.0713L36.0409 1.49994C34.7591 1.49989 33.4898 1.75232 32.3055 2.24283C31.1212 2.73333 30.0451 3.45229 29.1387 4.35867L27.1875 6.21421",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetTypeCat);
export default __webpack_public_path__ + "static/media/pet-type-cat.2edeb2ce.svg";
export { ForwardRef as ReactComponent };